import forOwn from 'mout/object/forOwn'
import contains from 'mout/array/contains'

/**
 * Creates an array of id's of a node and all its children (max depth)
 * @param {object} node the starting node from db.collection('knowledgeMapNodes')
 * @param {object} allNodes all of the nodes from db.collection('knowledgeMapNodes')
 * @returns {array} The id's of the node and all of its children, sub-children, etc. etc.
 */
export default function getAllChildrenNodes (node, allNodes) {
    let collectedNodes = [node.id,]
    if (node.children) {
      forOwn(node.children, (val, key, o) => {
        if (val) {
          if (!contains(collectedNodes, key)) {
            collectedNodes.push(key)
            if (allNodes[key].children) {
              getAllChildrenNodes(allNodes[key], allNodes).forEach((nodeKey) => {
                if (!contains(collectedNodes, nodeKey)) {
                  collectedNodes.push(nodeKey)
                }
              })
            }
          }
        }
      })
    }
    return collectedNodes
  }



// WEBPACK FOOTER //
// ./src/helpers/assessment/getAllChildrenNodes.js